import NumberFormat from 'react-number-format';
import { useSalesHistoryOfferAuction } from '../hooks';

export const CounterInfo = ({ vehicle }) => {
  const amount = useVehicleCounterInfo(vehicle);
  if (!amount) {
    return 'N/A';
  }
  return <NumberFormat displayType="text" prefix="$" value={amount} thousandSeparator />;
};

const useVehicleCounterInfo = vehicle => {
  const offerAuction = useSalesHistoryOfferAuction(vehicle.id);

  if (vehicle.active_alternative_offer) {
    return vehicle.active_alternative_offer.amount;
  }

  const lastOffer = offerAuction?.privateOffers?.find(offer => offer.sender?.role !== 'buyer');
  return lastOffer?.amount;
};
